export function swipersInit() {

  const swiperBanners = new Swiper('.swiper-banners', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination.banners',
      clickable: true,
    },
  });

  const swiperGalleryInstitutional = new Swiper('.swiper-gallery-institutional', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.institutional',
      prevEl: '.swiper-button-prev.institutional',
    },
    breakpoints: {
      900: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },
  });

  const swiperGalleryForwardingAgent = new Swiper('.swiper-gallery-forwarding-agent', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.forwarding-agent',
      prevEl: '.swiper-button-prev.forwarding-agent',
    },
    breakpoints: {
      900: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  const swiperGalleryBrisaPropaganda = new Swiper('.swiper-gallery-brisa-propaganda', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.brisa-propaganda',
      prevEl: '.swiper-button-prev.brisa-propaganda',
    },
  });

  const swiperGalleryWorkWithUs = new Swiper('.swiper-gallery-work-with-us', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.work-with-us',
      prevEl: '.swiper-button-prev.work-with-us',
    },
  });

  const swiperGalleryProtectSeguros = new Swiper('.swiper-gallery-protecta-seguros', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.protecta-seguros',
      prevEl: '.swiper-button-prev.protecta-seguros',
    },
  });
}
